import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24SettingB = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      }), /*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      }), /*#__PURE__*/jsxs("g", {
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        children: [/*#__PURE__*/jsx("path", {
          strokeWidth: 0.6,
          d: "M10.008 2.5c-.967 0-1.917.69-2.01 1.842v.005a2 2 0 0 1-2.354 1.807l-.006-.001a2 2 0 0 0-.384-.036c-1.63 0-2.632 1.967-1.499 3.297l.004.005a2 2 0 0 1-.387 2.942l-.005.003c-1.549 1.067-.9 3.488.975 3.638h.005a2 2 0 0 1 1.806 2.354v.006c-.247 1.34.825 2.367 1.979 2.367a1.96 1.96 0 0 0 1.283-.484l.004-.004a1.994 1.994 0 0 1 2.942.387l.002.005a1.95 1.95 0 0 0 1.63.867c.966 0 1.916-.69 2.009-1.842v-.005a2 2 0 0 1 2.354-1.807l.005.002q.198.035.385.035c1.63 0 2.632-1.967 1.498-3.297l-.003-.005a2 2 0 0 1 .387-2.941l.005-.004c1.549-1.067.9-3.488-.975-3.638h-.005a2 2 0 0 1-1.807-2.354l.001-.005c.247-1.341-.825-2.368-1.979-2.368a1.96 1.96 0 0 0-1.283.484l-.004.004a1.996 1.996 0 0 1-2.942-.387l-.002-.005a1.95 1.95 0 0 0-1.63-.867m0 .932c.248 0 .598.08.865.468a2.93 2.93 0 0 0 4.318.565q.308-.261.678-.262c.322 0 .638.15.848.403.14.167.29.453.214.87-.15.813.053 1.657.557 2.313a2.94 2.94 0 0 0 2.097 1.138c.696.056.899.617.945.788.046.17.15.758-.43 1.157a2.94 2.94 0 0 0-1.242 2.03 2.94 2.94 0 0 0 .678 2.288c.4.47.245.948.16 1.132-.14.304-.464.63-.95.63q-.104 0-.22-.022a3 3 0 0 0-.534-.049 2.946 2.946 0 0 0-2.919 2.703c-.051.646-.582.984-1.08.984-.247 0-.597-.08-.864-.468a2.93 2.93 0 0 0-4.318-.565 1.03 1.03 0 0 1-.678.262c-.322 0-.638-.15-.849-.403a1.02 1.02 0 0 1-.213-.87 2.94 2.94 0 0 0-.557-2.313 2.94 2.94 0 0 0-2.097-1.138c-.696-.056-.9-.617-.945-.788-.046-.17-.15-.757.43-1.157a2.94 2.94 0 0 0 1.242-2.03 2.94 2.94 0 0 0-.678-2.288 1.03 1.03 0 0 1-.16-1.132c.14-.304.463-.63.949-.63q.104 0 .221.022.266.05.534.05a2.946 2.946 0 0 0 2.919-2.704c.051-.646.582-.984 1.08-.984"
        }), /*#__PURE__*/jsx("path", {
          strokeWidth: 0.5,
          d: "M11.017 8.33a3.8 3.8 0 1 0 1.968 7.342 3.8 3.8 0 0 0-1.968-7.341m.246.917a2.853 2.853 0 0 1 3.49 2.015 2.853 2.853 0 0 1-2.015 3.49 2.853 2.853 0 0 1-3.49-2.014 2.853 2.853 0 0 1 2.015-3.49"
        })]
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24SettingB$1 = Svg24SettingB;

export { Svg24SettingB$1 as default };
